import React from 'react';
import { Container } from '../../components/ui/Container';
export function RefundPolicy() {
  return <>
      <section className="py-16 md:py-24" data-id="element-3915" data-mp="urwwjj5vajd1">
        <Container data-id="element-3916" data-mp="uv18x3thkles">
          <div className="max-w-4xl mx-auto" data-id="element-3917" data-mp="ptvaqqh245xv">
            <h1 className="font-display text-4xl md:text-6xl text-ink-900 leading-tight" data-id="element-3918" data-mp="pumyxg8br1e4">
              Refund Policy
            </h1>
            <p className="mt-4 text-ink-500" data-id="element-3919" data-mp="lumk3uhbco6j">
              <strong data-id="element-3920" data-mp="1ihhga49uhknd">Last updated:</strong> February 1, 2026
            </p>

            <div className="mt-10 space-y-8 text-ink-700 leading-relaxed" data-id="element-3921" data-mp="1djpmf4pn3ogj">
              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3922" data-mp="1dlseduacrrnw">
                Donations
              </h2>
              <p data-id="element-3923" data-mp="14rntrsltbcgt">
                Donations made to the International Islamic Learning Hub are
                considered irrevocable gifts. They are voluntary and
                non-refundable under any circumstances.
              </p>
              <div data-id="element-3924" data-mp="1wgqy18dp8mtg">
                <h3 className="font-display text-2xl md:text-3xl text-ink-900" data-id="element-3925" data-mp="1wg7e5m4hnocs">
                  Zakat Policy Notice
                </h3>
                <p className="mt-3" data-id="element-3926" data-mp="1ahz1iumo1cix">
                  We accept Sadaqah and corporate grants; please note that Zakat
                  is not accepted at this stage. If you have mistakenly sent
                  Zakat funds, please contact our support team immediately at{' '}
                  <a href="mailto:support@iilh.org" className="text-forest-700 underline underline-offset-2 hover:text-forest-800" data-id="element-3927" data-mp="mruzust1fmuk">
                    support@iilh.org
                  </a>{' '}
                  to arrange a prompt return of your contribution.
                </p>
              </div>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3928" data-mp="hta71eg485g5">
                Memberships
              </h2>
              <p data-id="element-3929" data-mp="2c6t2miql5dyt">
                <strong data-id="element-3930" data-mp="2c7b7u4v872iv">Active Periods:</strong> Membership fees are
                non-refundable once the membership period (month/year) has
                commenced.
              </p>
              <p data-id="element-3931" data-mp="25qj7ru9eilgu">
                <strong data-id="element-3932" data-mp="25pzuwrylyn9o">Cancellation:</strong> You may cancel your membership at
                any time to prevent billing for future periods.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3933" data-mp="20t9jihxr0ful">
                Paid Programs
              </h2>
              <p data-id="element-3934" data-mp="2tgn5xm3tlt0g">
                <strong data-id="element-3935" data-mp="2tf2e448w4o6a">Program-Specific Terms:</strong> Refund eligibility
                varies by course. Specific terms are outlined on the
                registration page for each program.
              </p>
              <p data-id="element-3936" data-mp="2jozjy0q1946d">
                <strong data-id="element-3937" data-mp="2joheqele7fmb">Partial Refunds:</strong> At the organization's sole
                discretion, partial refunds may be offered if a request is made
                prior to the commencement of the program.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3938" data-mp="37g52inncyakd">
                Exceptional Circumstances
              </h2>
              <p data-id="element-3939" data-mp="tyk2dyroveyt">
                We understand that life is unpredictable. Refund requests
                submitted due to exceptional circumstances (e.g., medical
                emergencies) may be reviewed on a case-by-case basis.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>;
}